import { Navigate, Outlet, useLocation } from 'react-router-dom';
import useAuthStore from '@store/authStore';
import LoadingSpinner from '@components/ui/LoadingSpinner';

const ProtectedRoute = ({ children, roles = [] }) => {
    const { isAuthenticated, isLoading, user, token } = useAuthStore();
    const location = useLocation();

    // If we have a token but no user yet, we are likely re-authenticating on refresh
    if (isLoading || (token && !user)) {
        return <LoadingSpinner fullScreen />;
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    // Check role if specified
    if (roles.length > 0 && !roles.includes(user?.role)) {
        return <Navigate to="/" replace />;
    }

    return children ? children : <Outlet />;
};

export default ProtectedRoute;
